import {
  GET_PRODUCT_RECOMMENDATIONS,
  GET_PRODUCT_RECOMMENDATIONS_SUCCESS,
  GET_PRODUCT_RECOMMENDATIONS_FAIL,
} from './actions';

const initialState = {
  loaded: false,
  productRecommendationSuccess: false,
  productRecommendationError: null,
  productRecommendationResponse: [],
};

export default function MarketingContentSection(
  state = initialState,
  action = {},
) {
  switch (action.type) {
    case GET_PRODUCT_RECOMMENDATIONS:
      return {
        ...state,
        loading: true,
        productRecommendationSuccess: false,
        productRecommendationError: null,
      };
    case GET_PRODUCT_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        productRecommendationSuccess: true,
        productRecommendationResponse: action.result || {},
      };
    case GET_PRODUCT_RECOMMENDATIONS_FAIL:
      return {
        ...state,
        loading: false,
        productRecommendationSuccess: false,
        productRecommendationError:
          typeof action.error === 'string'
            ? action.error
            : action.error?.errorMessage ||
              action.error?.message ||
              'Something went wrong with product recommendations',
      };
    default:
      return state;
  }
}
